import * as fontSizes from 'autogen/design-tokens/global/font';
import { getFontSizeNumbers } from 'components/generic/typography/shared/helpers';
import type { fontSizeTypes } from 'components/generic/typography/types';

const availableFontSizeArray = getFontSizeNumbers();

export default function fontSizeDecreaser(defaultSize: fontSizeTypes, decreaseAmount: number) {
    if (typeof defaultSize === 'object') {
        const discountSizes = {};

        Object.keys(defaultSize).forEach((key) => {
            const index = availableFontSizeArray.indexOf(defaultSize[key]);

            discountSizes[key] = availableFontSizeArray[index ? index - decreaseAmount : index];
        });

        return discountSizes;
    }

    const index = availableFontSizeArray.indexOf(defaultSize);

    return availableFontSizeArray[index ? index - decreaseAmount : index];
}
